import http from "@/http/aisea/axios";
const resource = "/gkmg/port_master/enterprises";

export default {
  add(payload) {
    return http.post(`${resource}/tasks`, payload);
  },

  bulks(payload) {
    return http.post(`${resource}/tasks/bulks`, payload);
  },

  import(file) {
    let formData = new FormData();
    formData.append("csv", file);
    return http.post(`${resource}/tasks/import`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    });
  },

  export(date) {
    return http.post(`${resource}/tasks/export/${date}`, null, {
      responseType: "blob",
    });
  },

  download(date) {
    return http.post(`${resource}/tasks/download/${date}`, null, {
      responseType: "blob",
    });
  },
};
